import Vue from "vue";
import ApiService from "@/common/api.service";
import {
  ORDER_SET_FORM,
  PURCHASE_AUTHORITY_CHECK,
  PLACE_ORDER,
  AUTH_PLACE_ORDER,
  PLACE_ORDER_PAYPAY,
  AUTH_PLACE_ORDER_PAYPAY,
  GET_ORDER,
  GET_ORDER_LIST,
  GET_ALL_ORDERS,
  CREATE_CREDIT_CARD,
  AUTH_PUBLIC_WITH_CUS_ORDER,
  AUTH_PUBLIC_ORDER,
  CONVENIENCE_STORES_CUS_ORDER,
  ORDER_ZIPCODE,
  RESET_ORDER_FORM,
  RESET_CODE_CONVENIENCE_STORES_ORDER,
  ORDER_WITHOUT_CARD_REGISTER,
  CLEAR_ERROR_ORDER,
  ORDER_CHANGE_DELIVERY_ADDRESS,
  AUTH_UPDATE_CARD,
  GET_PREFECTURE,
  VALIDATE_COUPON,
  CLEAR_COUPON,
  CLEAR_SHIPPING_NOODLE,
  CLEAR_SHIPPING_GOODS,
  GET_ORDER_PRICE,
  SET_ORDER_PRICE_PAYLOAD_ACTION,
  GET_COMPANY_PURCHASE_LIMIT_PER_DAY,
  AUTH_PLACE_ORDER_CREATE_CARD_VERITRANS,
  AUTH_PLACE_ORDER_UPDATE_CARD_VERITRANS,
  AUTH_TDS_ORDER_CONFIRM,
  AUTH_PLACE_ORDER_VERITRANS,
  PLACE_ORDER_VERITRANS,
  TDS_ORDER_CONFIRM,
  AUTH_TDS_ORDER_CARD_CONFIRM
} from "./actions.type";
import {
  SET_ORDER_FORM,
  SET_ORDER,
  SET_ORDER_ERROR,
  SET_ORDER_LIST,
  SET_ALL_ORDER,
  SET_ORDER_ZIPCODE,
  SET_RESET_ORDER_FORM,
  SET_CODE_CONVENIENCE_STORES_ORDER,
  SET_PREFECTURE,
  SET_VALID_PROMO_CODE,
  SET_SHIPPING_GOODS,
  SET_SHIPPING_NOODLE,
  SET_ORDER_PRICE,
  SET_ORDER_PRICE_PAYLOAD
} from "./mutations.type";
import fullwidth from "fullwidth";
import { COMPANY_ID, COD_FEE } from "@/common/config.js";
import JwtService from "@/common/jwt.service";

const initialState = {
  form: {
    first_name: null,
    family_name: null,
    first_name_furigana: null,
    family_name_furigana: null,
    phone_number: null,
    postal1: null,
    postal2: null,
    prefecture: null,
    city: null,
    address: null,
    room_number: null,
    mail: null,
    mail_confirm: null,
    payment_method: "creditCard",
    credit_card_number: null,
    credit_card_name: null,
    credit_card_month: 1,
    credit_card_year: null,
    credit_card_security_code: null,
    password: null,
    passwordConfirm: null,
    credit_card_token: null,
    masked_card_number: null,
    date_deliver: null,
    time_deliver: "",
    promo_code: null,
    delivery_first_name: null,
    delivery_family_name: null,
    delivery_first_name_kana: null,
    delivery_family_name_kana: null,
    delivery_zip_code: null,
    delivery_address_first: null,
    delivery_address_second: null,
    delivery_address_third: null,
    delivery_department: null,
    webcvstype: "001",
    deliveryToAddressType: null
  },
  valid_promo_code: null,
  error: "",
  orders: null,
  allOrders: null,
  temp: {
    zipcode: null,
    address1: null,
    address2: null,
    address3: null,
    delivery_zipcode: null,
    delivery_address1: null,
    delivery_address2: null,
    delivery_address3: null
  },
  codeConvenience: {},
  prefectureData: [],
  orderPrice: {},
  orderPricePayload: {},
  companyPurchaseLimit: {},
  charityTowel: "チャリティーハンドタオル",
  deliveryType: {
    nekoPos: "neko_pos",
    yamato: "yamato"
  }
};

export const state = { ...initialState };

export const actions = {
  [ORDER_SET_FORM]({ commit }, payload) {
    commit(SET_ORDER_FORM, payload);
  },

  [GET_ORDER_LIST]({ commit }, payload) {
    return ApiService.get(
      "v1/transactions",
      `with_customer?offset=${payload.offset}&limit=${
        payload.itemsPerPage
      }&sort=${payload.orderBy || "created_at.asc"}`
    )
      .then(response => {
        commit(SET_ORDER_LIST, response.data);
      })
      .catch(response => {
        commit(SET_ORDER_ERROR, response.data);
      });
  },
  [GET_ALL_ORDERS]({ commit }) {
    return ApiService.get(
      "v1/transactions",
      `with_customer?offset=0&limit=1000`
    )
      .then(response => {
        commit(SET_ALL_ORDER, response.data);
      })
      .catch(response => {
        commit(SET_ORDER_ERROR, response.data);
      });
  },
  [PURCHASE_AUTHORITY_CHECK]({ state }, payload) {
    let request = {
      company_id: COMPANY_ID,
      collaboration_products: payload.collaboration_products
    };

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v1/orders/purchase_authority_check`, request)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [PLACE_ORDER]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      token: state.form.credit_card_token,
      masked_card_number: state.form.masked_card_number,
      company_id: COMPANY_ID,
      products: products,
      price: payload.total,
      family_name: state.form.family_name,
      first_name: state.form.first_name,
      email: state.form.mail,
      password: state.form.password,
      password_confirmation: state.form.passwordConfirm,
      first_name_kana: state.form.first_name_furigana,
      family_name_kana: state.form.family_name_furigana,
      phone_number: state.form.phone_number,
      address_first: state.form.prefecture,
      address_second: state.form.city,
      address_third: fullwidth(state.form.address),
      department: state.form.room_number,
      zip_code: state.form.postal1 + state.form.postal2,
      coupon_id: payload.coupon ? payload.coupon.id : null,
      is_address_other: state.form.deliveryToAddressType === 1 ? false : true,
      due_date: payload.due_date ? payload.due_date : null
      // first_name_kana: state.form.first_name_furigana,
      // family_name_kana: state.form.family_name_furigana,
      // phone_number: state.form.phone_number,
      // zip_code: state.form.postal1 + state.form.postal2,
      // address:
      //   state.form.room_number +
      //   , " +
      //   state.form.address +
      //   ", " +
      //   state.form.city
    };
    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.mail,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];

    return new Promise((resolve, reject) => {
      if (payload.create === true) {
        Vue.axios
          .post(`v1/customers/escott/signup_and_pay_with_email`, requestData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      } else {
        Vue.axios
          .post(
            `v1/customers/escott/guest/signup_and_pay_with_email`,
            requestData
          )
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      }
    });
  },
  [AUTH_PLACE_ORDER]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          product_id: item.product_id,
          count: item.count,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      products: products,
      price: payload.total,
      coupon_id: payload.coupon ? payload.coupon.id : null
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.email,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];
    if (state.form.deliveryToAddressType === 3)
      requestData.addresses = [
        {
          first_name: state.form.selectCustomerAddress[0].first_name,
          family_name: state.form.selectCustomerAddress[0].family_name,
          first_name_kana: state.form.selectCustomerAddress[0].first_name_kana,
          family_name_kana:
            state.form.selectCustomerAddress[0].family_name_kana,
          phone_number: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zip_code: state.form.selectCustomerAddress[0].zip_code,
          address_first: state.form.selectCustomerAddress[0].address_first,
          address_second:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          address_third: state.form.selectCustomerAddress[0].department
        }
      ];

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v1/customers/escott/settlement`, requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [PLACE_ORDER_PAYPAY]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      token: state.form.credit_card_token,
      masked_card_number: state.form.masked_card_number,
      company_id: COMPANY_ID,
      products: products,
      price: payload.total,
      family_name: state.form.family_name,
      first_name: state.form.first_name,
      email: state.form.mail,
      password: state.form.password,
      password_confirmation: state.form.passwordConfirm,
      first_name_kana: state.form.first_name_furigana,
      family_name_kana: state.form.family_name_furigana,
      phone_number: state.form.phone_number,
      address_first: state.form.prefecture,
      address_second: state.form.city,
      address_third: fullwidth(state.form.address),
      department: state.form.room_number,
      zip_code: state.form.postal1 + state.form.postal2,
      coupon_id: payload.coupon ? payload.coupon.id : null,
      is_address_other: state.form.deliveryToAddressType === 1 ? false : true,
      redirect_url: `${document.location.protocol}//${document.location.host}/order-thanks`,
      redirect_type: "WEB_LINK"
      // first_name_kana: state.form.first_name_furigana,
      // family_name_kana: state.form.family_name_furigana,
      // phone_number: state.form.phone_number,
      // zip_code: state.form.postal1 + state.form.postal2,
      // address:
      //   state.form.room_number +
      //   , " +
      //   state.form.address +
      //   ", " +
      //   state.form.city
    };
    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.mail,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];

    return new Promise((resolve, reject) => {
      if (payload.create === true) {
        Vue.axios
          .post(`v1/customers/paypay/signup_and_pay_with_email`, requestData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      } else {
        Vue.axios
          .post(
            `v1/customers/paypay/guest/signup_and_pay_with_email`,
            requestData
          )
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      }
    });
  },
  [AUTH_PLACE_ORDER_PAYPAY]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          product_id: item.product_id,
          count: item.count,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      products: products,
      price: payload.total,
      coupon_id: payload.coupon ? payload.coupon.id : null,
      redirect_url: `${document.location.protocol}//${document.location.host}/order-thanks`,
      redirect_type: "WEB_LINK"
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.email,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];
    if (state.form.deliveryToAddressType === 3)
      requestData.addresses = [
        {
          first_name: state.form.selectCustomerAddress[0].first_name,
          family_name: state.form.selectCustomerAddress[0].family_name,
          first_name_kana: state.form.selectCustomerAddress[0].first_name_kana,
          family_name_kana:
            state.form.selectCustomerAddress[0].family_name_kana,
          phone_number: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zip_code: state.form.selectCustomerAddress[0].zip_code,
          address_first: state.form.selectCustomerAddress[0].address_first,
          address_second:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          address_third: state.form.selectCustomerAddress[0].department
        }
      ];

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v1/customers/paypay/settlement`, requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [CREATE_CREDIT_CARD]({ state }) {
    const requestData = {
      company_id: COMPANY_ID,
      credit_card_token: state.form.credit_card_token,
      masked_card_number: state.form.masked_card_number
    };

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v1/customers/escott/create_card`, requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [GET_ORDER](context) {
    return ApiService.get(
      "v1/transactions",
      "with_customer?limit=1000&offset=0"
    )
      .then(response => {
        context.commit(SET_ORDER, response.data);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [AUTH_PUBLIC_WITH_CUS_ORDER]({ state, commit }, payload) {
    let count = 0;
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        count += item.count;
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          product_options: product_options,
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });
    // let dueDate = new Date();
    // dueDate.setDate(dueDate.getDate() + ADD_DUE_DATE);
    // const year = dueDate.getFullYear();
    // let month = dueDate.getMonth() + 1;
    // let day = dueDate.getDate();
    // month = month.toString().padStart(2, "0");
    // day = day.toString().padStart(2, "0");
    // let dueDateString = year + "-" + month + "-" + day;

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      pay_method: payload.payMethod,
      products: products,
      price: payload.total,
      fees: payload.payMethod == "cash_on_delivery" ? COD_FEE : 0,
      due_date: payload.due_date,
      webcvstype: state.form.webcvstype,
      count: count,
      coupon_id: payload.coupon ? payload.coupon.id : null
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.email,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];
    if (state.form.deliveryToAddressType === 3)
      requestData.addresses = [
        {
          first_name: state.form.selectCustomerAddress[0].first_name,
          family_name: state.form.selectCustomerAddress[0].family_name,
          first_name_kana: state.form.selectCustomerAddress[0].first_name_kana,
          family_name_kana:
            state.form.selectCustomerAddress[0].family_name_kana,
          phone_number: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zip_code: state.form.selectCustomerAddress[0].zip_code,
          address_first: state.form.selectCustomerAddress[0].address_first,
          address_second:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          address_third: state.form.selectCustomerAddress[0].department
        }
      ];

    let url = `${process.env.VUE_APP_API_URL}`;
    if (requestData.pay_method === "comvenienceStore") {
      url = "/v1/customers/sbp/settlement_cstore";
    } else {
      url = "/v1/customers/public/transaction/with_customer";
    }
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, requestData)
        .then(({ data }) => {
          if (requestData.pay_method === "comvenienceStore") {
            commit(SET_CODE_CONVENIENCE_STORES_ORDER, data);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [AUTH_PUBLIC_ORDER]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          delivery_time: state.form.time_deliver,
          delivery_date: state.form.date_deliver,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });
    // let dueDate = new Date();
    // dueDate.setDate(dueDate.getDate() + ADD_DUE_DATE);
    // const year = dueDate.getFullYear();
    // let month = dueDate.getMonth() + 1;
    // let day = dueDate.getDate();
    // month = month.toString().padStart(2, "0");
    // day = day.toString().padStart(2, "0");
    // let dueDateString = year + "-" + month + "-" + day;
    const today = new Date();
    const dueDate = today;
    dueDate.setDate(today.getDate() + 7);

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      pay_method: payload.payMethod,
      products: products,
      price: payload.total,
      fees: payload.payMethod == "cash_on_delivery" ? COD_FEE : 0,
      // due_date: payload.payMethod == "bank_transfer" ? dueDateString : null,
      due_date: dueDate.toISOString().split("T")[0],
      family_name: state.form.family_name,
      first_name: state.form.first_name,
      first_name_kana: state.form.first_name_furigana,
      family_name_kana: state.form.family_name_furigana,
      email: state.form.mail,
      password: state.form.password,
      password_confirmation: state.form.passwordConfirm,
      zip_code: state.form.postal1 + state.form.postal2,
      address_first: state.form.prefecture,
      address_second: state.form.city,
      address_third: fullwidth(state.form.address),
      department: state.form.room_number,
      phone_number: state.form.phone_number,
      coupon_id: payload.coupon ? payload.coupon.id : null,
      is_address_other: state.form.deliveryToAddressType === 1 ? false : true
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.mail,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      if (payload.create === true) {
        Vue.axios
          .post(`v1/customers/public/transaction`, requestData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      } else {
        Vue.axios
          .post(`v1/customers/public/guest/transaction`, requestData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      }
    });
  },
  [ORDER_ZIPCODE]({ commit }, payload) {
    commit(SET_ORDER_ZIPCODE, payload);
  },
  [RESET_ORDER_FORM]({ commit }) {
    commit(SET_RESET_ORDER_FORM);
  },
  [RESET_CODE_CONVENIENCE_STORES_ORDER]({ commit }) {
    commit(SET_CODE_CONVENIENCE_STORES_ORDER);
  },
  [AUTH_UPDATE_CARD]({ state }, payload) {
    const requestData = {
      credit_card_token: payload.credit_card_token,
      masked_card_number: payload.masked_card_number
    };

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post("v1/customers/escott/update_card", requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [ORDER_CHANGE_DELIVERY_ADDRESS]({ state }, payload) {
    const prefecture = state.prefectureData.find(
      item => item.name === state.form.delivery_address_first
    );

    let requestData = {
      shipping: payload.shipping,
      customer_id: payload.user_id,
      company_id: COMPANY_ID,
      first_name: state.form.delivery_first_name,
      family_name: state.form.delivery_family_name,
      first_name_kana: state.form.delivery_first_name_kana,
      family_name_kana: state.form.delivery_family_name_kana,
      phone_number: state.form.phone_number,
      email: state.form.mail,
      zip_code: state.form.delivery_zip_code,
      address_first: state.form.delivery_address_first,
      address_second:
        state.form.delivery_address_second +
        fullwidth(state.form.delivery_address_third),
      address_third: state.form.delivery_department,
      prefecture_id: prefecture.id
    };
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.email,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post("v1/customers/address", requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [ORDER_WITHOUT_CARD_REGISTER]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          product_options: product_options,
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      products: products,
      price: payload.total,
      token: state.form.credit_card_token,
      masked_card_number: state.form.masked_card_number,
      coupon_id: payload.coupon ? payload.coupon.id : null
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.email,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];
    if (state.form.deliveryToAddressType === 3)
      requestData.addresses = [
        {
          first_name: state.form.selectCustomerAddress[0].first_name,
          family_name: state.form.selectCustomerAddress[0].family_name,
          first_name_kana: state.form.selectCustomerAddress[0].first_name_kana,
          family_name_kana:
            state.form.selectCustomerAddress[0].family_name_kana,
          phone_number: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zip_code: state.form.selectCustomerAddress[0].zip_code,
          address_first: state.form.selectCustomerAddress[0].address_first,
          address_second:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          address_third: state.form.selectCustomerAddress[0].department
        }
      ];

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.post("v1/customers/escott/register_settlement", requestData)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.message;
          reject(response);
        });
    });
  },
  [CONVENIENCE_STORES_CUS_ORDER]({ state, commit }, payload) {
    let count = 0;
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        count += item.count;
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              product_option_id: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          product_id: item.product_id,
          count: item.count,
          delivery_date: state.form.date_deliver,
          delivery_time: state.form.time_deliver,
          product_options: product_options,
          delivery_type:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      company_id: COMPANY_ID,
      pay_method: payload.payMethod,
      products: products,
      price: payload.total,
      family_name: state.form.family_name,
      first_name_kana: state.form.first_name_furigana,
      family_name_kana: state.form.family_name_furigana,
      first_name: state.form.first_name,
      email: state.form.mail,
      password: state.form.password,
      password_confirmation: state.form.passwordConfirm,
      webcvstype: state.form.webcvstype,
      phone_number: state.form.phone_number,
      issue_type: "1",
      zip_code_first: state.form.postal1,
      zip_code_second: state.form.postal2,
      address_first: state.form.prefecture,
      address_second: state.form.city,
      address_third: fullwidth(state.form.address),
      count: count,
      coupon_id: payload.coupon ? payload.coupon.id : null,
      is_address_other: state.form.deliveryToAddressType === 1 ? false : true,
      due_date: payload.due_date
    };

    if (state.form.deliveryToAddressType === 1)
      requestData.addresses = [
        {
          first_name: state.form.first_name,
          family_name: state.form.family_name,
          first_name_kana: state.form.first_name_furigana,
          family_name_kana: state.form.family_name_furigana,
          phone_number: state.form.phone_number,
          email: state.form.mail,
          zip_code:
            state.form.postal1.toString() + state.form.postal2.toString(),
          address_first: state.form.prefecture,
          address_second: state.form.city + fullwidth(state.form.address),
          address_third: state.form.room_number
        }
      ];
    if (state.form.deliveryToAddressType === 2)
      requestData.addresses = [
        {
          first_name: state.form.delivery_first_name,
          family_name: state.form.delivery_family_name,
          first_name_kana: state.form.delivery_first_name_kana,
          family_name_kana: state.form.delivery_family_name_kana,
          phone_number: state.form.delivery_phone_number,
          email: state.form.mail,
          zip_code: state.form.delivery_zip_code,
          address_first: state.form.delivery_address_first,
          address_second:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          address_third: state.form.delivery_department
        }
      ];

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      if (payload.create === true) {
        ApiService.post(
          "v1/customers/sbp/signup_cstore_settlement",
          requestData
        )
          .then(({ data }) => {
            // context.commit(SET_AUTH, data);
            commit(SET_CODE_CONVENIENCE_STORES_ORDER, data);
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      } else {
        ApiService.post(
          "v1/customers/sbp/guest/signup_cstore_settlement",
          requestData
        )
          .then(({ data }) => {
            // context.commit(SET_AUTH, data);
            commit(SET_CODE_CONVENIENCE_STORES_ORDER, data);
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.message;
            reject(response);
          });
      }
    });
  },
  [CLEAR_ERROR_ORDER]({ commit }) {
    commit(SET_ORDER_ERROR, "");
  },
  [GET_PREFECTURE]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService.get("v1/prefectures?limit=100&offset=0")
        .then(({ data }) => {
          commit(SET_PREFECTURE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [VALIDATE_COUPON]({ state, commit }) {
    return new Promise((resolve, reject) => {
      ApiService.get(
        "v1/coupons",
        `by_coupon_code?coupon_code=${state.form.promo_code}&company_id=${COMPANY_ID}`
      )
        .then(({ data }) => {
          commit(SET_VALID_PROMO_CODE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_ORDER_PRICE]({ rootState, state, commit }, payload) {
    const prefectureData = rootState.order.prefectureData;
    const prefectureID = prefectureData.find(o => o.name === payload.address);
    if (!payload || payload.cart.length == 0) return;

    const products = payload.cart.map(item => {
      let productOptions = [];
      if (item.product_options && item.product_options.length > 0) {
        productOptions = item.product_options.map(option => {
          return {
            product_option_id: option.product_option_id,
            count: option.count
          };
        });
      }

      return {
        product_id: item.product_id,
        count: item.count,
        product_options: productOptions
      };
    });

    const request = {
      company_id: COMPANY_ID,
      prefecture_id: prefectureID && prefectureID.id,
      pay_method:
        state.form.payment_method == "daibiki"
          ? "cash_on_delivery"
          : state.form.payment_method,
      products: products
    };

    return new Promise((resolve, reject) => {
      ApiService.post("v1/carts/total_price", request)
        .then(({ data }) => {
          commit(SET_ORDER_PRICE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [GET_COMPANY_PURCHASE_LIMIT_PER_DAY]({ state }, payload) {
    const request = {
      date_from: payload.date_from,
      date_to: payload.date_to,
      company_id: COMPANY_ID
    };

    return new Promise((resolve, reject) => {
      ApiService.post("v1/deliveries/purchase_limit_per_date", request)
        .then(({ data }) => {
          state.companyPurchaseLimit = data;
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [AUTH_PLACE_ORDER_CREATE_CARD_VERITRANS]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              productOptionId: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          deliveryDate: state.form.date_deliver,
          deliveryTime: state.form.time_deliver,
          productId: item.product_id,
          count: item.count,
          productOptions: product_options,
          deliveryType:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      token: state.form.credit_card_token,
      maskedCardNumber: state.form.masked_card_number,
      tokenExpireDate: state.form.token_expire_date,
      cardExpireAt: state.form.card_expiration,
      cardholderName: state.form.cardholder_name,
      shipping: payload.shipping,
      products: products,
      price: payload.total,
      couponCode: payload.coupon ? payload.coupon.id : null,
      redirectionUri: payload.redirectionUri
    };

    if (state.form.deliveryToAddressType === 1) {
      requestData.addresses = [
        {
          firstName: state.form.first_name,
          familyName: state.form.family_name,
          firstNameKana: state.form.first_name_furigana,
          familyNameKana: state.form.family_name_furigana,
          phoneNumber: state.form.phone_number,
          email: state.form.mail,
          zipCode:
            state.form.postal1.toString() + state.form.postal2.toString(),
          addressFirst: state.form.prefecture,
          addressSecond: state.form.city + fullwidth(state.form.address),
          addressThird: state.form.room_number
        }
      ];
    }
    if (state.form.deliveryToAddressType === 2) {
      requestData.addresses = [
        {
          firstName: state.form.delivery_first_name,
          familyName: state.form.delivery_family_name,
          firstNameKana: state.form.delivery_first_name_kana,
          familyNameKana: state.form.delivery_family_name_kana,
          phoneNumber: state.form.delivery_phone_number,
          email: state.form.email,
          zipCode: state.form.delivery_zip_code,
          addressFirst: state.form.delivery_address_first,
          addressSecond:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          addressThird: state.form.delivery_department
        }
      ];
    }
    if (state.form.deliveryToAddressType === 3) {
      requestData.addresses = [
        {
          firstName: state.form.selectCustomerAddress[0].first_name,
          familyName: state.form.selectCustomerAddress[0].family_name,
          firstNameKana: state.form.selectCustomerAddress[0].first_name_kana,
          familyNameKana: state.form.selectCustomerAddress[0].family_name_kana,
          phoneNumber: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zipCode: state.form.selectCustomerAddress[0].zip_code,
          addressFirst: state.form.selectCustomerAddress[0].address_first,
          addressSecond:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          addressThird: state.form.selectCustomerAddress[0].department
        }
      ];
    }

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(
          `v2/customers/veritrans/credit/tds/payments/create_card/auth`,
          requestData
        )
        .then(({ data }) => {
          const webhookData = {
            idempotency_key: data.idempotency_key,
            invoice_history_id: data.invoice_history_id,
            price: data.price,
            subscription: data.subscription,
            shipping_map: data.shipping_map,
            webhook_url: data.webhook_url,
            coupon: data.coupon,
            payment_products: data.payment_products,
            masked_card_number: data.masked_card_number
          };
          JwtService.setWebhookData(JSON.stringify(webhookData));
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [AUTH_PLACE_ORDER_UPDATE_CARD_VERITRANS]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              productOptionId: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          deliveryDate: state.form.date_deliver,
          deliveryTime: state.form.time_deliver,
          productId: item.product_id,
          count: item.count,
          productOptions: product_options,
          deliveryType:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      token: state.form.credit_card_token,
      maskedCardNumber: state.form.masked_card_number,
      tokenExpireDate: state.form.token_expire_date,
      cardExpireAt: state.form.card_expiration,
      cardholderName: state.form.cardholder_name,
      shipping: payload.shipping,
      products: products,
      price: payload.total,
      couponCode: payload.coupon ? payload.coupon.id : null,
      redirectionUri: payload.redirectionUri
    };

    if (state.form.deliveryToAddressType === 1) {
      requestData.addresses = [
        {
          firstName: state.form.first_name,
          familyName: state.form.family_name,
          firstNameKana: state.form.first_name_furigana,
          familyNameKana: state.form.family_name_furigana,
          phoneNumber: state.form.phone_number,
          email: state.form.mail,
          zipCode:
            state.form.postal1.toString() + state.form.postal2.toString(),
          addressFirst: state.form.prefecture,
          addressSecond: state.form.city + fullwidth(state.form.address),
          addressThird: state.form.room_number
        }
      ];
    }
    if (state.form.deliveryToAddressType === 2) {
      requestData.addresses = [
        {
          firstName: state.form.delivery_first_name,
          familyName: state.form.delivery_family_name,
          firstNameKana: state.form.delivery_first_name_kana,
          familyNameKana: state.form.delivery_family_name_kana,
          phoneNumber: state.form.delivery_phone_number,
          email: state.form.email,
          zipCode: state.form.delivery_zip_code,
          addressFirst: state.form.delivery_address_first,
          addressSecond:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          addressThird: state.form.delivery_department
        }
      ];
    }
    if (state.form.deliveryToAddressType === 3) {
      requestData.addresses = [
        {
          firstName: state.form.selectCustomerAddress[0].first_name,
          familyName: state.form.selectCustomerAddress[0].family_name,
          firstNameKana: state.form.selectCustomerAddress[0].first_name_kana,
          familyNameKana: state.form.selectCustomerAddress[0].family_name_kana,
          phoneNumber: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zipCode: state.form.selectCustomerAddress[0].zip_code,
          addressFirst: state.form.selectCustomerAddress[0].address_first,
          addressSecond:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          addressThird: state.form.selectCustomerAddress[0].department
        }
      ];
    }

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(
          `v2/customers/veritrans/credit/tds/payments/update_card/auth`,
          requestData
        )
        .then(({ data }) => {
          const webhookData = {
            idempotency_key: data.idempotency_key,
            invoice_history_id: data.invoice_history_id,
            price: data.price,
            subscription: data.subscription,
            shipping_map: data.shipping_map,
            webhook_url: data.webhook_url,
            coupon: data.coupon,
            payment_products: data.payment_products,
            masked_card_number: data.masked_card_number
          };
          JwtService.setWebhookData(JSON.stringify(webhookData));
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [AUTH_PLACE_ORDER_VERITRANS]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              productOptionId: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          deliveryDate: state.form.date_deliver,
          deliveryTime: state.form.time_deliver,
          productId: item.product_id,
          count: item.count,
          productOptions: product_options,
          deliveryType:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      shipping: payload.shipping,
      products: products,
      price: payload.total,
      couponCode: payload.coupon ? payload.coupon.id : null,
      redirectionUri: payload.redirectionUri
    };

    if (state.form.deliveryToAddressType === 1) {
      requestData.addresses = [
        {
          firstName: state.form.first_name,
          familyName: state.form.family_name,
          firstNameKana: state.form.first_name_furigana,
          familyNameKana: state.form.family_name_furigana,
          phoneNumber: state.form.phone_number,
          email: state.form.mail,
          zipCode:
            state.form.postal1.toString() + state.form.postal2.toString(),
          addressFirst: state.form.prefecture,
          addressSecond: state.form.city + fullwidth(state.form.address),
          addressThird: state.form.room_number
        }
      ];
    }
    if (state.form.deliveryToAddressType === 2) {
      requestData.addresses = [
        {
          firstName: state.form.delivery_first_name,
          familyName: state.form.delivery_family_name,
          firstNameKana: state.form.delivery_first_name_kana,
          familyNameKana: state.form.delivery_family_name_kana,
          phoneNumber: state.form.delivery_phone_number,
          email: state.form.email,
          zipCode: state.form.delivery_zip_code,
          addressFirst: state.form.delivery_address_first,
          addressSecond:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          addressThird: state.form.delivery_department
        }
      ];
    }
    if (state.form.deliveryToAddressType === 3) {
      requestData.addresses = [
        {
          firstName: state.form.selectCustomerAddress[0].first_name,
          familyName: state.form.selectCustomerAddress[0].family_name,
          firstNameKana: state.form.selectCustomerAddress[0].first_name_kana,
          familyNameKana: state.form.selectCustomerAddress[0].family_name_kana,
          phoneNumber: state.form.selectCustomerAddress[0].phone_number,
          email: state.form.selectCustomerAddress[0].email,
          zipCode: state.form.selectCustomerAddress[0].zip_code,
          addressFirst: state.form.selectCustomerAddress[0].address_first,
          addressSecond:
            state.form.selectCustomerAddress[0].address_second +
            fullwidth(state.form.selectCustomerAddress[0].address_third),
          addressThird: state.form.selectCustomerAddress[0].department
        }
      ];
    }

    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v2/customers/veritrans/credit/tds/payments`, requestData)
        .then(({ data }) => {
          const webhookData = {
            idempotency_key: data.idempotency_key,
            invoice_history_id: data.invoice_history_id,
            price: data.price,
            subscription: data.subscription,
            shipping_map: data.shipping_map,
            webhook_url: data.webhook_url,
            coupon: data.coupon,
            payment_products: data.payment_products
          };
          JwtService.setWebhookData(JSON.stringify(webhookData));
          resolve(data);
        })
        .catch(({ response }) => {
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [AUTH_TDS_ORDER_CONFIRM]({ state }, payload) {
    const webhookData =
      JwtService.getWebhookData() && JSON.parse(JwtService.getWebhookData());
    let requestData = {
      orderId: payload.orderId,
      idempotencyKey: webhookData.idempotency_key,
      webhookUrl: webhookData.webhook_url,
      invoiceHistoryId: webhookData.invoice_history_id,
      shippingMap: webhookData.shipping_map,
      subscription: webhookData.subscription,
      price: webhookData.price,
      coupon: webhookData.coupon,
      paymentProducts: webhookData.payment_products
    };

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v2/customers/veritrans/credit/tds/payments/execute`, requestData)
        .then(({ data }) => {
          JwtService.destroyWebhookData();
          if (data.success) {
            resolve(data);
          } else {
            state.error = "3Dセキュア認証に失敗しました";
            reject(data);
          }
        })
        .catch(({ response }) => {
          JwtService.destroyWebhookData();
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [AUTH_TDS_ORDER_CARD_CONFIRM]({ state }, payload) {
    const webhookData =
      JwtService.getWebhookData() && JSON.parse(JwtService.getWebhookData());
    let requestData = {
      orderId: payload.orderId,
      maskedCardNumber: webhookData.masked_card_number,
      idempotencyKey: webhookData.idempotency_key,
      webhookUrl: webhookData.webhook_url,
      invoiceHistoryId: webhookData.invoice_history_id,
      shippingMap: webhookData.shipping_map,
      subscription: webhookData.subscription,
      price: webhookData.price,
      coupon: webhookData.coupon,
      paymentProducts: webhookData.payment_products
    };

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(
          `v2/customers/veritrans/credit/tds/payments/card/execute`,
          requestData
        )
        .then(({ data }) => {
          JwtService.destroyWebhookData();
          if (data.success) {
            resolve(data);
          } else {
            state.error = "3Dセキュア認証に失敗しました";
            reject(data);
          }
        })
        .catch(({ response }) => {
          JwtService.destroyWebhookData();
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [PLACE_ORDER_VERITRANS]({ state }, payload) {
    const products =
      payload.cart &&
      payload.cart.length &&
      payload.cart.map(item => {
        let product_options = [];
        if (item.product_options && item.product_options.length > 0) {
          product_options = item.product_options.map(itemop => {
            return {
              productOptionId: itemop.product_option_id,
              count: itemop.count
            };
          });
        }
        return {
          productId: item.product_id,
          count: item.count,
          deliveryDate: state.form.date_deliver,
          deliveryTime: state.form.time_deliver,
          productOptions: product_options,
          deliveryType:
            item.name === state.charityTowel
              ? state.deliveryType.nekoPos
              : state.deliveryType.yamato
        };
      });

    let requestData = {
      apiKey: process.env.VUE_APP_API_KEY,
      shipping: payload.shipping,
      token: state.form.credit_card_token,
      maskedCardNumber: state.form.masked_card_number,
      tokenExpireDate: state.form.token_expire_date,
      cardExpireAt: state.form.card_expiration,
      cardholderName: state.form.cardholder_name,
      products: products,
      price: payload.total,
      familyName: state.form.family_name,
      firstName: state.form.first_name,
      email: state.form.mail,
      password: state.form.password,
      passwordConfirmation: state.form.passwordConfirm,
      firstNameKana: state.form.first_name_furigana,
      familyNameKana: state.form.family_name_furigana,
      phoneNumber: state.form.phone_number,
      addressFirst: state.form.prefecture,
      addressSecond: state.form.city,
      addressThird: fullwidth(state.form.address),
      department: state.form.room_number,
      zipCode: state.form.postal1 + state.form.postal2,
      couponCode: payload.coupon ? payload.coupon.id : null,
      isAddressOther: state.form.deliveryToAddressType === 1 ? false : true,
      redirectionUri: payload.redirectionUri
    };
    if (state.form.deliveryToAddressType === 1) {
      requestData.addresses = [
        {
          firstName: state.form.first_name,
          familyName: state.form.family_name,
          firstNameKana: state.form.first_name_furigana,
          familyNameKana: state.form.family_name_furigana,
          phoneNumber: state.form.phone_number,
          email: state.form.mail,
          zipCode:
            state.form.postal1.toString() + state.form.postal2.toString(),
          addressFirst: state.form.prefecture,
          addressSecond: state.form.city + fullwidth(state.form.address),
          addressThird: state.form.room_number
        }
      ];
    }
    if (state.form.deliveryToAddressType === 2) {
      requestData.addresses = [
        {
          firstName: state.form.delivery_first_name,
          familyName: state.form.delivery_family_name,
          firstNameKana: state.form.delivery_first_name_kana,
          familyNameKana: state.form.delivery_family_name_kana,
          phoneNumber: state.form.delivery_phone_number,
          email: state.form.mail,
          zipCode: state.form.delivery_zip_code,
          addressFirst: state.form.delivery_address_first,
          addressSecond:
            state.form.delivery_address_second +
            fullwidth(state.form.delivery_address_third),
          addressThird: state.form.delivery_department
        }
      ];
    }

    return new Promise((resolve, reject) => {
      if (payload.create === true) {
        Vue.axios
          .post(`v2/veritrans/credit/tds/payments/auth`, requestData)
          .then(({ data }) => {
            const webhookData = {
              idempotency_key: data.idempotency_key,
              invoice_history_id: data.invoice_history_id,
              price: data.price,
              subscription: data.subscription,
              shipping_map: data.shipping_map,
              webhook_url: data.webhook_url,
              coupon: data.coupon,
              payment_products: data.payment_products
            };
            JwtService.setWebhookData(JSON.stringify(webhookData));
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.detail
              ? response.data.detail
              : response.data.message;
            reject(response);
          });
      } else {
        Vue.axios
          .post(`v2/veritrans/credit/tds/payments/guest/auth`, requestData)
          .then(({ data }) => {
            const webhookData = {
              idempotency_key: data.idempotency_key,
              invoice_history_id: data.invoice_history_id,
              price: data.price,
              subscription: data.subscription,
              shipping_map: data.shipping_map,
              webhook_url: data.webhook_url,
              coupon: data.coupon,
              payment_products: data.payment_products
            };
            JwtService.setWebhookData(JSON.stringify(webhookData));
            resolve(data);
          })
          .catch(({ response }) => {
            state.error = response.data.detail
              ? response.data.detail
              : response.data.message;
            reject(response);
          });
      }
    });
  },
  [TDS_ORDER_CONFIRM]({ state }, payload) {
    const webhookData =
      JwtService.getWebhookData() && JSON.parse(JwtService.getWebhookData());
    let requestData = {
      apiKey: process.env.VUE_APP_API_KEY,
      orderId: payload.orderId,
      idempotencyKey: webhookData.idempotency_key,
      webhookUrl: webhookData.webhook_url,
      invoiceHistoryId: webhookData.invoice_history_id,
      shippingMap: webhookData.shipping_map,
      subscription: webhookData.subscription,
      price: webhookData.price,
      coupon: webhookData.coupon,
      paymentProducts: webhookData.payment_products
    };

    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`v2/veritrans/credit/tds/payments/execute`, requestData)
        .then(({ data }) => {
          JwtService.destroyWebhookData();
          if (data.success) {
            resolve(data);
          } else {
            state.error = "3Dセキュア認証に失敗しました";
            reject(data);
          }
        })
        .catch(({ response }) => {
          JwtService.destroyWebhookData();
          state.error = response.data.detail
            ? response.data.detail
            : response.data.message;
          reject(response);
        });
    });
  },
  [CLEAR_COUPON]({ commit }) {
    commit(SET_VALID_PROMO_CODE, null);
  },
  [CLEAR_SHIPPING_NOODLE]({ commit }) {
    commit(SET_SHIPPING_NOODLE, 0);
  },
  [CLEAR_SHIPPING_GOODS]({ commit }) {
    commit(SET_SHIPPING_GOODS, 0);
  },
  [SET_ORDER_PRICE_PAYLOAD_ACTION]({ commit }, payload) {
    commit(SET_ORDER_PRICE_PAYLOAD, payload);
  }
};

const getters = {
  orderForm: state => state.form,
  orderList(state) {
    return state.orders;
  },
  orderError: state => state.error,
  allOrders: state => state.allOrders,
  orderAddressZipcode: state => state.temp,
  codeConvenience: state => state.codeConvenience,
  prefectureData: state => state.prefectureData,
  validPromoCode: state => state.valid_promo_code,
  orderPrice: state => state.orderPrice,
  orderPricePayload: state => state.orderPricePayload,
  companyPurchaseLimit: state => state.companyPurchaseLimit
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_ORDER_FORM](state, payload) {
    state.form = { ...state.form, ...payload };
  },
  [SET_ORDER_LIST](state, payload) {
    state.orders = payload;
  },
  [SET_ORDER_ERROR](state, payload) {
    state.error = payload;
  },
  [SET_ORDER](state, data) {
    state.orders = data;
  },
  [SET_ALL_ORDER](state, data) {
    state.allOrders = data;
  },
  [SET_ORDER_ZIPCODE](state, payload) {
    state.temp = { ...state.temp, ...payload };
  },
  [SET_RESET_ORDER_FORM](state) {
    state.form = initialState.form;
    state.temp = initialState.temp;
  },
  [SET_CODE_CONVENIENCE_STORES_ORDER](state, data) {
    state.codeConvenience = data;
  },
  [SET_PREFECTURE](state, data) {
    state.prefectureData = data;
  },
  [SET_VALID_PROMO_CODE](state, data) {
    state.valid_promo_code = data;
  },
  [SET_ORDER_PRICE](state, data) {
    state.orderPrice = data;
  },
  [SET_ORDER_PRICE_PAYLOAD](state, data) {
    state.orderPricePayload = data;
  }
};
export default {
  state,
  actions,
  getters,
  mutations
};
